import React from 'react';
import { Button, Text } from '@wix/wix-base-ui';
import * as symbols from '@wix/santa-editor-symbols';
import { translate } from '@/i18n';
import { connectWithScope, type InferComponentProps } from '@/apilib';
import { PromoteScope } from '../../../scope';
import { MarketingPanel } from '../common/marketingPanel';
import promoteBi from '../common/bi/promoteBi';

export interface OwnProps {}

type MarketingIntegrationsPanelProps = InferComponentProps<
  typeof mapStateToProps,
  typeof mapDispatchToProps,
  OwnProps
>;

const TAB_NAME = 'MarketingIntegrationsPanel';
const PRODUCT_NAME = 'MarketingIntegrations';

const MarketingIntegrationsPanel = React.memo<MarketingIntegrationsPanelProps>(
  (props: MarketingIntegrationsPanelProps) => {
    React.useEffect(() => {
      props.sendBi(promoteBi.events.TAB_VIEW, {
        ...props.biBaseParams,
        tab_name: TAB_NAME,
        product_name: PRODUCT_NAME,
      });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const onPressCTA = () => {
      props.sendBi(promoteBi.events.PRODUCT_CLICK, {
        ...props.biBaseParams,
        tab_name: TAB_NAME,
        product_name: PRODUCT_NAME,
      });
      props.navigateToMarketingIntegrations();
    };

    return (
      <MarketingPanel
        logo={
          <symbols.symbol
            name="promoteMarketingIntegrationsPanelLogo"
            className="logo"
          />
        }
        title={
          <Text
            skin="standard"
            size="large"
            weight="bold"
            enableEllipsis={false}
          >
            {'Promote_Marketing_Integrations_Title'}
          </Text>
        }
        body={
          <Text skin="standard" size="small" enableEllipsis={false}>
            {'Promote_Marketing_Integrations_Description'}
          </Text>
        }
        actions={
          <Button onClick={onPressCTA} className="btn-md">
            {translate('Promote_Marketing_Integrations_MainButton')}
          </Button>
        }
      />
    );
  },
);

const mapStateToProps = (scope: PromoteScope) => {
  const biBaseParams = promoteBi.biUtils.getBiBaseParams(scope);

  return {
    biBaseParams,
    msid: scope.editorAPI.dsRead.generalInfo.getMetaSiteId(),
  };
};
const mapDispatchToProps = (scope: PromoteScope) => {
  return {
    navigateToMarketingIntegrations: () =>
      scope.editorAPI.account.openSettings({ tab: 'MarketingIntegrations' }),
    sendBi: (event: ValueOf<typeof promoteBi.events>, parameters: object) => {
      promoteBi.report(event, parameters);
    },
  };
};

MarketingIntegrationsPanel.displayName = 'MarketingIntegrationsPanel';

export default connectWithScope(
  () => PromoteScope,
  MarketingIntegrationsPanel,
  mapStateToProps,
  mapDispatchToProps,
);
